export default __webpack_public_path__ + "static/media/writer.97730e8f.png";